<h1 class="page-title mb-5">الخدمات الإلكترونية</h1>

<div class="all-services-container container-fluid py-5">
  <div class="row g-4">
    <div class="col-lg-3 col-md-4 col-sm-6" *ngFor="let service of services">
      <div class="service-card" [routerLink]="service.route" style="cursor: pointer">
        <div class="icon-wrapper">
          <i [class]="service.icon"></i>
        </div>
        <h3 class="service-title">{{ service.title }}</h3>
      </div>
    </div>
  </div>
</div>